<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h4>{{ $t('header-accept-as-employee') }}</h4>
                <TabView v-model:activeIndex="active">
                    <TabPanel :header="$t('personal-info')">
                        <AcceptApplicantPersonalInfo ref="personal" :submitted="submitted"></AcceptApplicantPersonalInfo>
                        <Button label="Next" class="p-button p-component p-button-primary" @click="saveNik"/>
                        <small class="p-invalid" v-if="submitted">
                            Check Your Input Again .
                        </small>
                    </TabPanel>
                    <TabPanel :header="$t('setup-placement')" >
                        <AcceptApplicantSetupPlacementVue ref="placement" :submitted="submitted"></AcceptApplicantSetupPlacementVue>
                        <Button label="Next" class="p-button p-component p-button-primary" @click="savePlacement"/>
                    </TabPanel>
                    <TabPanel :header="$t('setup-salary')" >
                        <AcceptApplicantSetupSalaryVue ref="salary" :submitted="submitted"></AcceptApplicantSetupSalaryVue>
                        <Button label="Next" class="p-button p-component p-button-primary" @click="saveAll"/>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import axios from "axios";
import AcceptApplicantPersonalInfo from "./Components/AcceptApplicantPersonalInfo.vue";
import AcceptApplicantSetupPlacementVue from "./Components/AcceptApplicantSetupPlacement.vue";
import AcceptApplicantSetupSalaryVue from "./Components/AcceptApplicantSetupSalary.vue";

export default {
    components: {InputText, Dropdown, Button, TabView, TabPanel, AcceptApplicantPersonalInfo, AcceptApplicantSetupPlacementVue, AcceptApplicantSetupSalaryVue},
    layout: AppLayout,
    props: ['models'],
    data(){
        return{
            showDialog: this.status,
            placements: [],
            divisions: [],
            teams: [],
            positions: [],
            submitted: false,
            active: 0,
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data)=>{
                this.placements = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
            .then((data)=>{
                this.divisions = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/teams`)
            .then((data)=>{
                this.teams = data.data;
            });
            axios.get(`${this.$page.props.appUrl}api/positions`)
            .then((data)=>{
                this.positions = data.data;
            });
        },
        saveNik(){
            this.submitted = true;
            let nik = this.$refs.personal.form.nik;

            if(nik){
                this.submitted = false;
                this.active = 1;
            }
        },
        savePlacement(){
            this.submitted = true;
            let placement = this.$refs.placement.form;
            let validated = true;

            if(Object.keys(placement).length === 0){
                validated = false;
            }

            for (const record in placement) {
                if (!placement[record]) {
                    validated = false;
                }
            }

            console.log(validated);
            if(validated){
                this.submitted = false;
                this.active = 2;
            }
        },
        saveAll(){
            this.submitted = true;
            let applicant_id = this.$page.props.candidate.data.id;
            let nik = this.$refs.personal.form.nik;
            let placement = this.$refs.placement.form;
            let salary = this.$refs.salary.form;
            let validated = true;

            let payload = {nik: nik, ...placement, ...salary};
            if(Object.keys(salary).length === 0){
                validated = false;
            }

            if(validated){
                this.submitted = false;
                axios.post(`${this.$page.props.appUrl}api/applicants/${applicant_id}/accept2`,payload)
                .then((data) => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Successful",
                        detail: "Candidate Accepted",
                        life: 3000,
                    });
                    window.location = `${this.$page.props.appUrl}candidates`;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error When Accepting Candidate",
                        detail: error,
                        life: 3000,
                    });
                })
            }
        },
    },
}
</script>
